import * as React from 'react';
import CardContent from '@mui/material/CardContent';

export default function StyledCardFormContent({ sx, ...restProps }) {
  return (
    <CardContent sx={{ padding: { xs: '15px', sm: '48px' }, ...sx }} {...restProps} />
  );
}
